module.exports = __webpack_public_path__ + "media/site/images/technologies/docker-icon-a9d1636c8f29d6a08d4dcc8676bd6fb7.svg";